"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import type { ExportStats } from "./types";

interface ExportSummaryProps {
  stats: ExportStats;
  searchTerm: string;
}

export function ExportSummary({ stats, searchTerm }: ExportSummaryProps) {
  return (
    <div className="bg-card-50 rounded-lg p-4">
      <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Export Summary</h3>
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span className="text-gray-600 dark:text-gray-400">Total Records:</span>
          <span className="ml-2 font-medium">{stats.totalItems}</span>
        </div>
        <div>
          <span className="text-gray-600 dark:text-gray-400">Will Export:</span>
          <span className="ml-2 font-medium">{stats.willExportCount}</span>
        </div>
        {stats.hasActiveFilters && (
          <div className="col-span-2">
            <Badge variant="outline" className="text-xs">
              Active Filters Applied
            </Badge>
          </div>
        )}
        {stats.hasSearch && (
          <div className="col-span-2">
            <Badge variant="outline" className="text-xs">
              Search Applied: "{searchTerm}"
            </Badge>
          </div>
        )}
      </div>
    </div>
  );
}
